
import React from "react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";

const TeamSection = () => {
  const team = [
    {
      name: "Hassaana Begam V",
      role: "Founder and CEO",
      image: "/lovable-uploads/e9196fc0-cfdf-40b6-b53f-fdf15738cd51.png",
      fallback: "HB",
    },
    {
      name: "Ashwin Ragav",
      role: "Chief Technology Officer",
      image: "/lovable-uploads/fff145f9-3ac3-42d1-875f-dd488aa24451.png",
      fallback: "AR",
    },
    {
      name: "Bhavya S Suravajhala",
      role: "Chief Management Officer",
      image: "/lovable-uploads/f8c04bc2-3425-4d84-a2f6-170415dc0361.png",
      fallback: "BS",
    },
  ];

  return (
    <section className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">Our Leadership Team</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {team.map((member) => (
            <Card key={member.name} className="text-center hover:shadow-lg transition-shadow overflow-hidden">
              <CardContent className="p-0">
                <div className="p-6 pb-4">
                  <div className="mx-auto mb-4 rounded-full overflow-hidden border-4 border-brand-orange/10 shadow-lg w-36 h-36">
                    <AspectRatio ratio={1/1}>
                      <Avatar className="w-full h-full">
                        <AvatarImage 
                          src={member.image} 
                          alt={member.name} 
                          className="object-cover object-center w-full h-full"
                        />
                        <AvatarFallback className="text-2xl">{member.fallback}</AvatarFallback>
                      </Avatar>
                    </AspectRatio>
                  </div>
                  <h3 className="text-xl font-semibold mb-2">{member.name}</h3>
                  <p className="text-muted-foreground">{member.role}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
